// "use client"

// import { useState, useEffect } from "react"
// import { Link, useNavigate } from "react-router-dom"
// import axios from "axios"
// import { toast } from "react-toastify"
// import { baseUrl } from "../../config/baseUrl"
// // import { hasPermission, PERMISSIONS } from "../../utils/permissions"

// export default function RoleList() {
//     const navigate = useNavigate()
//     const [roles, setRoles] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [deleteLoading, setDeleteLoading] = useState(null)
//     const [searchTerm, setSearchTerm] = useState("")

//     // const canCreate = hasPermission(PERMISSIONS.ROLE_CREATE)
//     // const canEdit = hasPermission(PERMISSIONS.ROLE_EDIT)
//     // const canDelete = hasPermission(PERMISSIONS.ROLE_DELETE)

//     useEffect(() => {
//         // if (!hasPermission(PERMISSIONS.ROLE_VIEW)) {
//         //     toast.error("You do not have permission to view roles")
//         //     navigate("/")
//         //     return
//         // }
//         fetchRoles()
//     }, [])

//     const fetchRoles = async () => {
//         try {
//             // setLoading(true)
//             const token = localStorage.getItem("token")
//             const response = await axios.get(`${baseUrl}/role/role-list`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             })

//             if (response.data.status) {
//                 setRoles(response.data.data || [])
//             }
//         } catch (error) {
//             console.error("Error fetching roles:", error)
//             toast.error("Failed to fetch roles")
//         } finally {
//             setLoading(false)
//         }
//     }

//     const handleDelete = async (id) => {
//         // if (!canDelete) {
//         //     toast.error("You do not have permission to delete roles")
//         //     return
//         // }

//         if (window.confirm("Are you sure you want to delete this role?")) {
//             try {
//                 setDeleteLoading(id)
//                 const token = localStorage.getItem("token")
//                 const response = await axios.delete(`${baseUrl}/role/role-delete/${id}`, {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 })

//                 if (response.data.status) {
//                     toast.success("Role deleted successfully")
//                     fetchRoles()
//                 }
//             } catch (error) {
//                 console.error("Error deleting role:", error)
//                 toast.error("Failed to delete role")
//             } finally {
//                 setDeleteLoading(null)
//             }
//         }
//     }

//     const filteredRoles = roles.filter((role) => role.name.toLowerCase().includes(searchTerm.toLowerCase()))

//     return (
//         <div className=" main-sec">
//             <div className="page-header">
//                 <div>
//                     <h2 className="page-title">Role Management</h2>
//                     <p className="page-subtitle">Manage roles and permissions for your application</p>
//                 </div>

//                 <Link to="/roles/create" className="btn-primary-custom">
//                     <i className="fa fa-plus me-2"></i>
//                     Create Role
//                 </Link>

//             </div>

//             <div className="filter-section">
//                 <div className="search-box">
//                     <i className="fa fa-search search-icon"></i>
//                     <input
//                         type="text"
//                         placeholder="Search roles..."
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         className="search-input"
//                     />
//                 </div>
//             </div>

//             {loading ? (
//                 <div className="loading-container">
//                     <div className="spinner"></div>
//                     <p>Loading roles...</p>
//                 </div>
//             ) : (
//                 <div className="roles-grid">
//                     {filteredRoles.length === 0 ? (
//                         <div className="empty-state">
//                             <i className="fa fa-users-cog empty-icon"></i>
//                             <h3>No roles found</h3>
//                             <p>Create your first role to get started</p>
//                         </div>
//                     ) : (
//                         filteredRoles.map((role) => (
//                             <div key={role._id} className="role-card">
//                                 <div className="role-card-header">
//                                     <div className="role-icon">
//                                         <i className="fa fa-shield-alt"></i>
//                                     </div>
//                                     <h3 className="role-name">{role.name}</h3>
//                                 </div>

//                                 <div className="role-card-body">
//                                     <div className="permission-count">
//                                         <span className="count-badge">{role.permissions?.length || 0}</span>
//                                         <span className="count-label">Permissions</span>
//                                     </div>

//                                     <div className="permissions-preview">
//                                         {role.permissions?.slice(0, 3).map((permission, idx) => (
//                                             <span key={idx} className="permission-tag">
//                                                 {permission.split(":")[0]}
//                                             </span>
//                                         ))}
//                                         {role.permissions?.length > 3 && (
//                                             <span className="permission-tag more">+{role.permissions.length - 3} more</span>
//                                         )}
//                                     </div>
//                                 </div>

//                                 <div className="role-card-footer">

//                                     <button
//                                         onClick={() => navigate(`/roles/edit/${role._id}`)}
//                                         className="btn-action btn-edit"
//                                         title="Edit Role"
//                                     >
//                                         <i className="fa fa-edit"></i>
//                                         Edit
//                                     </button>


//                                     <button
//                                         onClick={() => handleDelete(role._id)}
//                                         className="btn-action btn-delete"
//                                         disabled={deleteLoading === role._id}
//                                         title="Delete Role"
//                                     >
//                                         {deleteLoading === role._id ? (
//                                             <>
//                                                 <div className="btn-spinner"></div>
//                                                 Deleting...
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <i className="fa fa-trash"></i>
//                                                 Delete
//                                             </>
//                                         )}
//                                     </button>

//                                 </div>
//                             </div>
//                         ))
//                     )}
//                 </div>
//             )}

//             <style jsx>{`
//         .role-list-container {
//           padding: 24px;
//           max-width: 1400px;
//           margin: 0 auto;
//         }

//         .page-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 32px;
//           flex-wrap: wrap;
//           gap: 16px;
//         }

//         .page-title {
//           font-size: 28px;
//           font-weight: 600;
//           color: #1e293b;
//           margin: 0;
//         }

//         .page-subtitle {
//           color: #64748b;
//           font-size: 14px;
//           margin: 4px 0 0 0;
//         }

//         .btn-primary-custom {
//           display: inline-flex;
//           align-items: center;
//           padding: 10px 20px;
//           background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
//           color: white;
//           border: none;
//           border-radius: 8px;
//           font-weight: 500;
//           text-decoration: none;
//           transition: all 0.3s ease;
//           box-shadow: 0 2px 8px rgba(99, 102, 241, 0.2);
//         }

//         .btn-primary-custom:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
//           color: white;
//         }

//         .filter-section {
//           margin-bottom: 24px;
//         }

//         .search-box {
//           position: relative;
//           max-width: 400px;
//         }

//         .search-icon {
//           position: absolute;
//           left: 16px;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #94a3b8;
//         }

//         .search-input {
//           width: 100%;
//           padding: 12px 16px 12px 44px;
//           border: 1px solid #e2e8f0;
//           border-radius: 8px;
//           font-size: 14px;
//           transition: all 0.3s ease;
//           background: white;
//         }

//         .search-input:focus {
//           outline: none;
//           border-color: #6366f1;
//           box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
//         }

//         .loading-container {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           padding: 60px 20px;
//           color: #64748b;
//         }

//         .spinner {
//           width: 48px;
//           height: 48px;
//           border: 4px solid #e2e8f0;
//           border-top-color: #6366f1;
//           border-radius: 50%;
//           animation: spin 0.8s linear infinite;
//           margin-bottom: 16px;
//         }

//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }

//         .roles-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
//           gap: 24px;
//         }

//         .role-card {
//           background: white;
//           border: 1px solid #e2e8f0;
//           border-radius: 12px;
//           overflow: hidden;
//           transition: all 0.3s ease;
//         }

//         .role-card:hover {
//           box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
//           transform: translateY(-4px);
//         }

//         .role-card-header {
//           padding: 24px;
//           background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
//           border-bottom: 1px solid #e2e8f0;
//           display: flex;
//           align-items: center;
//           gap: 16px;
//         }

//         .role-icon {
//           width: 48px;
//           height: 48px;
//           background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           font-size: 20px;
//         }

//         .role-name {
//           font-size: 18px;
//           font-weight: 600;
//           color: #1e293b;
//           margin: 0;
//         }

//         .role-card-body {
//           padding: 24px;
//         }

//         .permission-count {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//           margin-bottom: 16px;
//         }

//         .count-badge {
//           display: inline-flex;
//           align-items: center;
//           justify-content: center;
//           width: 40px;
//           height: 40px;
//           background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
//           color: white;
//           border-radius: 8px;
//           font-weight: 600;
//           font-size: 16px;
//         }

//         .count-label {
//           color: #64748b;
//           font-size: 14px;
//         }

//         .permissions-preview {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 8px;
//         }

//         .permission-tag {
//           padding: 4px 12px;
//           background: #f1f5f9;
//           color: #475569;
//           border-radius: 6px;
//           font-size: 12px;
//           font-weight: 500;
//           text-transform: capitalize;
//         }

//         .permission-tag.more {
//           background: #e0e7ff;
//           color: #4f46e5;
//         }

//         .role-card-footer {
//           padding: 16px 24px;
//           background: #f8fafc;
//           display: flex;
//           gap: 12px;
//           border-top: 1px solid #e2e8f0;
//         }

//         .btn-action {
//           flex: 1;
//           padding: 8px 16px;
//           border: none;
//           border-radius: 6px;
//           font-size: 14px;
//           font-weight: 500;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 6px;
//         }

//         .btn-edit {
//           background: #f0fdf4;
//           color: #16a34a;
//           border: 1px solid #bbf7d0;
//         }

//         .btn-edit:hover {
//           background: #dcfce7;
//           border-color: #86efac;
//         }

//         .btn-delete {
//           background: #fef2f2;
//           color: #dc2626;
//           border: 1px solid #fecaca;
//         }

//         .btn-delete:hover:not(:disabled) {
//           background: #fee2e2;
//           border-color: #fca5a5;
//         }

//         .btn-delete:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }

//         .btn-spinner {
//           width: 14px;
//           height: 14px;
//           border: 2px solid #fca5a5;
//           border-top-color: #dc2626;
//           border-radius: 50%;
//           animation: spin 0.6s linear infinite;
//         }

//         .empty-state {
//           text-align: center;
//           padding: 60px 20px;
//           grid-column: 1 / -1;
//         }

//         .empty-icon {
//           font-size: 64px;
//           color: #cbd5e1;
//           margin-bottom: 16px;
//         }

//         .empty-state h3 {
//           font-size: 20px;
//           font-weight: 600;
//           color: #475569;
//           margin: 0 0 8px 0;
//         }

//         .empty-state p {
//           color: #94a3b8;
//           margin: 0;
//         }

//         @media (max-width: 768px) {
//           .page-header {
//             flex-direction: column;
//             align-items: flex-start;
//           }

//           .roles-grid {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>
//         </div>
//     )
// }
"use client"

import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import axios from "axios"
import { toast } from "react-toastify"
import { baseUrl } from "../../config/baseUrl"
import PermissionGuard from "../../Component/PermissionGuard/PermissionGuard"
import { PERMISSIONS } from "../../utils/permissions"

export default function RoleList() {
  const navigate = useNavigate()
  const [roles, setRoles] = useState([])
  const [loading, setLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    fetchRoles()
  }, [])

  const fetchRoles = async () => {
    try {
      const token = localStorage.getItem("token")
      const response = await axios.get(`${baseUrl}/role/role-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (response.data.status) {
        setRoles(response.data.data || [])
      }
    } catch (error) {
      console.error("Error fetching roles:", error)
      toast.error("Failed to fetch roles")
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this role?")) {
      try {
        setDeleteLoading(id)
        const token = localStorage.getItem("token")
        const response = await axios.delete(`${baseUrl}/role/role-delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.data.status) {
          toast.success("Role deleted successfully")
          fetchRoles()
        }
      } catch (error) {
        console.error("Error deleting role:", error)
        toast.error("Failed to delete role")
      } finally {
        setDeleteLoading(null)
      }
    }
  }

  const filteredRoles = roles.filter((role) => role.name.toLowerCase().includes(searchTerm.toLowerCase()))

  return (
    <div className="main-sec">
      <div className="page-header">
        <div>
          <h2 className="page-title">Role Management</h2>
          <p className="page-subtitle">Manage roles and permissions for your application</p>
        </div>
        <PermissionGuard permission={PERMISSIONS.ROLE_CREATE}>
          <Link to="/roles/create" className="btn-primary-custom">
            <i className="fa fa-plus me-2"></i>
            Create Role
          </Link>
        </PermissionGuard>
      </div>

      <div className="filter-section">
        <div className="search-box">
          <i className="fa fa-search search-icon"></i>
          <input
            type="text"
            placeholder="Search roles..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading roles...</p>
        </div>
      ) : (
        <div className="roles-grid">
          {filteredRoles.length === 0 ? (
            <div className="empty-state">
              <i className="fa fa-users-cog empty-icon"></i>
              <h3>No roles found</h3>
              <p>Create your first role to get started</p>
            </div>
          ) : (
            filteredRoles.map((role) => (
              <div key={role._id} className="role-card">
                <div className="role-card-header">
                  <div className="role-icon">
                    <i className="fa fa-shield-alt"></i>
                  </div>
                  <h3 className="role-name">{role.name}</h3>
                </div>

                <div className="role-card-body">
                  <div className="permission-count">
                    <span className="count-badge">{role.permissions?.length || 0}</span>
                    <span className="count-label">Permissions</span>
                  </div>

                  <div className="permissions-preview">
                    {role.permissions?.slice(0, 3).map((permission, idx) => (
                      <span key={idx} className="permission-tag">
                        {permission.split(":")[0]}
                      </span>
                    ))}
                    {role.permissions?.length > 3 && (
                      <span className="permission-tag more">+{role.permissions.length - 3} more</span>
                    )}
                  </div>
                </div>

                <div className="role-card-footer">
                  <PermissionGuard permission={PERMISSIONS.ROLE_EDIT}>
                    <button
                      onClick={() => navigate(`/roles/edit/${role._id}`)}
                      className="btn-action btn-edit"
                      title="Edit Role"
                    >
                      <i className="fa fa-edit"></i>
                      Edit
                    </button>
                  </PermissionGuard>

                  <PermissionGuard permission={PERMISSIONS.ROLE_DELETE}>
                    <button
                      onClick={() => handleDelete(role._id)}
                      className="btn-action btn-delete"
                      disabled={deleteLoading === role._id}
                      title="Delete Role"
                    >
                      {deleteLoading === role._id ? (
                        <>
                          <div className="btn-spinner"></div>
                          Deleting...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-trash"></i>
                          Delete
                        </>
                      )}
                    </button>
                  </PermissionGuard>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      <style jsx>{`
                .role-list-container {
                    padding: 24px;
                    max-width: 1400px;
                    margin: 0 auto;
                }

                .page-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 32px;
                    flex-wrap: wrap;
                    gap: 16px;
                }

                .page-title {
                    font-size: 28px;
                    font-weight: 600;
                    color: #1e293b;
                    margin: 0;
                }

                .page-subtitle {
                    color: #64748b;
                    font-size: 14px;
                    margin: 4px 0 0 0;
                }

                .btn-primary-custom {
                    display: inline-flex;
                    align-items: center;
                    padding: 10px 20px;
                    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
                    color: white;
                    border: none;
                    border-radius: 8px;
                    font-weight: 500;
                    text-decoration: none;
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.2);
                }

                .btn-primary-custom:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
                    color: white;
                }

                .filter-section {
                    margin-bottom: 24px;
                }

                .search-box {
                    position: relative;
                    max-width: 400px;
                }

                .search-icon {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                }

                .search-input {
                    width: 100%;
                    padding: 12px 16px 12px 44px;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    font-size: 14px;
                    transition: all 0.3s ease;
                    background: white;
                }

                .search-input:focus {
                    outline: none;
                    border-color: #6366f1;
                    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
                }

                .loading-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 60px 20px;
                    color: #64748b;
                }

                .spinner {
                    width: 48px;
                    height: 48px;
                    border: 4px solid #e2e8f0;
                    border-top-color: #6366f1;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                    margin-bottom: 16px;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                .roles-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
                    gap: 24px;
                }

                .role-card {
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    overflow: hidden;
                    transition: all 0.3s ease;
                }

                .role-card:hover {
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
                    transform: translateY(-4px);
                }

                .role-card-header {
                    padding: 24px;
                    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                    border-bottom: 1px solid #e2e8f0;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }

                .role-icon {
                    width: 48px;
                    height: 48px;
                    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 20px;
                }

                .role-name {
                    font-size: 18px;
                    font-weight: 600;
                    color: #1e293b;
                    margin: 0;
                }

                .role-card-body {
                    padding: 24px;
                }

                .permission-count {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 16px;
                }

                .count-badge {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
                    color: white;
                    border-radius: 8px;
                    font-weight: 600;
                    font-size: 16px;
                }

                .count-label {
                    color: #64748b;
                    font-size: 14px;
                }

                .permissions-preview {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;
                }

                .permission-tag {
                    padding: 4px 12px;
                    background: #f1f5f9;
                    color: #475569;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 500;
                    text-transform: capitalize;
                }

                .permission-tag.more {
                    background: #e0e7ff;
                    color: #4f46e5;
                }

                .role-card-footer {
                    padding: 16px 24px;
                    background: #f8fafc;
                    display: flex;
                    gap: 12px;
                    border-top: 1px solid #e2e8f0;
                }

                .btn-action {
                    flex: 1;
                    padding: 8px 16px;
                    border: none;
                    border-radius: 6px;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                }

                .btn-edit {
                    background: #f0fdf4;
                    color: #16a34a;
                    border: 1px solid #bbf7d0;
                }

                .btn-edit:hover {
                    background: #dcfce7;
                    border-color: #86efac;
                }

                .btn-delete {
                    background: #fef2f2;
                    color: #dc2626;
                    border: 1px solid #fecaca;
                }

                .btn-delete:hover:not(:disabled) {
                    background: #fee2e2;
                    border-color: #fca5a5;
                }

                .btn-delete:disabled {
                    opacity: 0.6;
                    cursor: not-allowed;
                }

                .btn-spinner {
                    width: 14px;
                    height: 14px;
                    border: 2px solid #fca5a5;
                    border-top-color: #dc2626;
                    border-radius: 50%;
                    animation: spin 0.6s linear infinite;
                }

                .empty-state {
                    text-align: center;
                    padding: 60px 20px;
                    grid-column: 1 / -1;
                }

                .empty-icon {
                    font-size: 64px;
                    color: #cbd5e1;
                    margin-bottom: 16px;
                }

                .empty-state h3 {
                    font-size: 20px;
                    font-weight: 600;
                    color: #475569;
                    margin: 0 0 8px 0;
                }

                .empty-state p {
                    color: #94a3b8;
                    margin: 0;
                }

                @media (max-width: 768px) {
                    .page-header {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .roles-grid {
                        grid-template-columns: 1fr;
                    }
                }
            `}</style>
    </div>
  )
}
